import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, Form, Button } from "react-bootstrap";
import { cloneDeep } from "lodash";

// Redux
import { connect } from "react-redux";
import * as actions from "../../redux/actions";

// Component
import Icon from "../Icon";
import Color from "../../assets/color";

// Helper
import { order_type } from "../../helpers/Constant";

class ModalSelectOrderType extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orderType: {
        valid: true,
        selectedValue: null,
        value: this.props.orderType,
        validation: {
          error_message: "Please select collect mode.",
        },
      },
    };
  }

  componentDidMount() {
    this.props.onGetOrderType();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.orderType !== this.props.orderType) {
      let orderType = cloneDeep(this.state.orderType);
      orderType.value = orderType;

      this.setState({
        orderType: orderType,
      });
    }

    if (prevProps.currentOrderType !== this.props.currentOrderType) {
      let orderType = cloneDeep(this.state.orderType);
      orderType.selectedValue = this.props.currentOrderType;
      this.setState({
        orderType: orderType,
      });
    }
  }

  _hideModal = () => {
    this.props.onHideSelectOrderTypeModal();
  };

  _handleOnChange = (e, viewMenuOnly = false, onChange = true) => {
    let orderType = cloneDeep(this.state.orderType);
    let validate = true;
    orderType.selectedValue = e.target.value;

    if (viewMenuOnly === true && e.target.value === "delivery") {
      orderType.selectedValue = null;
      validate = false;
      if (onChange === true) alert("This shop is currently closed.");
    }

    this.setState(
      { orderType: orderType },
      () => validate === true && this._validateOnChange()
    );
  };

  _validateOnChange = () => {
    let orderType = cloneDeep(this.state.orderType);
    let selectedValue = orderType.selectedValue;

    orderType.valid = selectedValue === null ? false : true;
    this.setState({
      orderType: orderType,
    });

    return orderType.valid;
  };

  _onUpdateOrderType = () => {
    if (this._validateOnChange()) {
      let orderType = cloneDeep(this.state.orderType);
      let selectedValue = orderType.selectedValue;

      orderType.value = selectedValue;

      this.setState(
        {
          showSelectOrderType: false,
          orderType: orderType,
        },
        () => {
          this.props.onUpdateOrderType(orderType.value);
          this.props.onHideSelectOrderTypeModal();
        }
      );
    }
  };

  render() {
    const { selectOrderTypeModalVisible, restaurantDetail } = this.props;
    const { orderType } = this.state;
    const restaurantSetting = restaurantDetail.RestaurantSetting;
    const orderTypeAvailable =
      restaurantSetting &&
      (restaurantSetting["delivery"] || restaurantSetting["pick_up"]);
    const deliveryViewMenuOnly =
      restaurantSetting &&
      !restaurantDetail.openNow &&
      !restaurantSetting.preorder;
    return (
      <Modal
        size="xs"
        show={selectOrderTypeModalVisible}
        onHide={this._hideModal}
        aria-labelledby="example-modal-sizes-title-lg"
        centered={true}
        className="modal-select-order-type"
        backdrop="static"
      >
        <div className="inner-container">
          <div className="position-relative text-right">
            <div className="btn-close" onClick={this._hideModal}>
              <Icon
                type="custom"
                name="closecircle"
                color={Color.black}
                size={30}
              />
            </div>
          </div>
          <h3>Select Collect Mode</h3>
          {orderTypeAvailable ? (
            <h5>Please select the collect mode before continue order:</h5>
          ) : (
            <h5>No Delivery and Pick Up service in this shop.</h5>
          )}
          <Form>
            {order_type.map((type, index) => {
              let checked = orderType.selectedValue === type.value;
              return (
                restaurantSetting &&
                restaurantSetting[type.restaurantSetting] && (
                  <Form.Group className="radio-container" key={index}>
                    <Form.Check
                      custom
                      type="radio"
                      name="order-type-modal"
                      label={type.text}
                      id={`modal-custom-${type.value}`}
                      value={type.value}
                      onChange={(e) =>
                        this._handleOnChange(e, deliveryViewMenuOnly)
                      }
                      onBlur={(e) =>
                        this._handleOnChange(e, deliveryViewMenuOnly, false)
                      }
                      checked={checked}
                    />
                  </Form.Group>
                )
              );
            })}
            {restaurantSetting && restaurantSetting["dine_in"] && (
              <div
                style={{
                  backgroundColor: "#f2f4f7",
                  padding: "1rem",
                  fontFamily: "Lato Bold",
                  color: "#555555",
                  marginBottom: "1rem",
                }}
              >
                <p style={{ padding: 0, margin: 0 }}>
                  <b>Dine In?</b>
                </p>
                <p
                  style={{
                    padding: 0,
                    margin: 0,
                    fontSize: 12,
                    paddingTop: 5,
                    paddingBottom: 5,
                  }}
                >
                  Open LOLOL App & Scan QR Code
                </p>
                <div>
                  <a
                    href="https://itunes.apple.com/my/app/lolol-pay-less-get-more/id1440552007?mt=8"
                    rel="noopener noreferrer"
                    target="_blank"
                    className={`animated download-ios fadeIn`}
                  >
                    <img
                      src={require("../../assets/img/home_banner/delivery/download-ios.png")}
                      alt=""
                      style={{ width: "47.5%", marginRight: "5%" }}
                    />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.lolol.userApp"
                    rel="noopener noreferrer"
                    target="_blank"
                    className={`animated download-android fadeIn`}
                  >
                    <img
                      src={require("../../assets/img/home_banner/delivery/download-android.png")}
                      alt=""
                      style={{ width: "47.5%" }}
                    />
                  </a>
                </div>
              </div>
            )}
            {!this.state.orderType.valid ? (
              <span className="text-danger">
                {this.state.orderType.validation.error_message}
              </span>
            ) : null}
            <div className="text-right">
              {orderTypeAvailable && (
                <Button
                  className="btn-confirm"
                  onClick={() => this._onUpdateOrderType()}
                >
                  Confirm
                </Button>
              )}
            </div>
          </Form>
        </div>
      </Modal>
    );
  }
}
ModalSelectOrderType.propTypes = {
  selectOrderTypeModalVisible: PropTypes.bool.isRequired,
  // Function
  onHideSelectOrderTypeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    orderType: state.App.selectedOrderType,
    currentOrderType: state.App.currentOrderType,
    selectOrderTypeModalVisible: state.App.selectOrderTypeModalVisible,
    restaurantDetail: state.Restaurant.restaurantDetail,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onHideSelectOrderTypeModal: () =>
      dispatch(actions.hideSelectOrderTypeModal()),
    onGetOrderType: () => dispatch(actions.getOrderType()),
    onUpdateOrderType: (param) => dispatch(actions.updateOrderType(param)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalSelectOrderType);
